import { ApiRequestEnum } from 'src/app/core/enums/api-request.enum';
import { ApiService } from 'src/app/core/services/api.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AppointmentService {
	constructor(
		private apiService: ApiService,
	) {
	}

	doRegister(params) {
		return this.apiService.post(ApiRequestEnum.APPOINTMENT_CREATE, params);
	}

	GetAppointments(params: any) {
		return this.apiService.post(ApiRequestEnum.GETALLAPPOINTMENT, params);
	}

	rescheduleAppointment(appointmentID: string, params: any) {
		return this.apiService.put(ApiRequestEnum.APPOINTMENT_RESCHEDULE.replace('{{appointment_uuid}}', appointmentID), params)
	}

	CancelAppoitment(appointmentID: string, params: any) {
		return this.apiService.post(ApiRequestEnum.CANCEL_APPOINTMENT.replace('{{appointment_uuid}}', appointmentID), params)
	}
}
